var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as actions from 'app/actions/checklist';
import http from 'app/services/http';
import { batch } from 'react-redux';
const defaultInspectionSort = config.inspectionColumns[0];
const defaultTemplateSort = config.checklistTemplateColumns[0];
const emptyFilters = {
    from: '',
    to: '',
    status: [],
    template_id: [],
    employee_id: [],
    transport_id: [],
};
let inspectionListRequestVersion = 0;
let inspectionDetailRequestVersion = 0;
const initialState = {
    inspectionItems: [],
    inspectionHasMore: false,
    inspectionSearchValue: '',
    inspectionSelectedItem: null,
    inspectionSortSelectedItem: {
        name: defaultInspectionSort.name,
        order: defaultInspectionSort.order,
    },
    inspectionSelectedFilters: Object.assign({}, emptyFilters),
    inspectionSelectedFiltersLength: 0,
    inspectionFiltersData: {
        template: [],
        employee: [],
        transport: [],
    },
    templateItems: [],
    templateSearchValue: '',
    templateSelectedItem: null,
    templateSortSelectedItem: {
        name: defaultTemplateSort.name,
        order: defaultTemplateSort.order,
    },
    templateGroupItems: [],
    groupItems: [],
    groupSelectedItem: null,
    groupSearchValue: '',
};
const normalizeInspectionItem = (item) => {
    const createdAtLocal = moment.utc(item.created_at).local().format('YYYY-MM-DD HH:mm:ss');
    const inspectedAtLocal = item.inspected_at ? moment.utc(item.inspected_at).local().format('YYYY-MM-DD HH:mm:ss') : null;
    return Object.assign(Object.assign({}, item), { inspected_at: inspectedAtLocal, 
        // «Время проведения» в таблице: осмотр на клиенте, иначе доставка на сервер.
        created_at: inspectedAtLocal || createdAtLocal, delivered_at: createdAtLocal });
};
export const checklistReducer = (state = initialState, action) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14;
    switch (action.type) {
        case 'CHECKLIST_SET_INSPECTION_ITEMS': {
            const { items, bool: hasMore, append } = (_a = action.payload) !== null && _a !== void 0 ? _a : {};
            const normalizedItems = ((_b = items) !== null && _b !== void 0 ? _b : []).map(normalizeInspectionItem);
            return Object.assign(Object.assign({}, state), { inspectionItems: append ? [...state.inspectionItems, ...normalizedItems] : normalizedItems, inspectionHasMore: !!hasMore });
        }
        case 'CHECKLIST_SET_INSPECTION_SEARCH_VALUE': {
            const { value } = (_c = action.payload) !== null && _c !== void 0 ? _c : {};
            return Object.assign(Object.assign({}, state), { inspectionSearchValue: value !== null && value !== void 0 ? value : '' });
        }
        case 'CHECKLIST_SET_INSPECTION_SELECTED_ITEM': {
            const { data } = (_d = action.payload) !== null && _d !== void 0 ? _d : {};
            return Object.assign(Object.assign({}, state), { inspectionSelectedItem: (_e = data) !== null && _e !== void 0 ? _e : null });
        }
        case 'CHECKLIST_SET_INSPECTION_SORT_SELECTED_ITEM': {
            const data = (_f = action.payload) === null || _f === void 0 ? void 0 : _f.data;
            if (!data) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { inspectionSortSelectedItem: {
                    name: data.name,
                    order: state.inspectionSortSelectedItem.name !== data.name ? data.order : state.inspectionSortSelectedItem.order === 'ASC' ? 'DESC' : 'ASC',
                } });
        }
        case 'CHECKLIST_SET_INSPECTION_SELECTED_FILTERS': {
            const data = (_h = (_g = action.payload) === null || _g === void 0 ? void 0 : _g.data) !== null && _h !== void 0 ? _h : emptyFilters;
            return Object.assign(Object.assign({}, state), { inspectionSelectedFilters: data, inspectionSelectedFiltersLength: Object.values(data).reduce((accumulator, currentValue) => {
                    switch (typeof currentValue) {
                        case 'string':
                            if (currentValue.length)
                                accumulator++;
                            break;
                        case 'object':
                            if (currentValue && currentValue.length) {
                                accumulator += currentValue.length;
                            }
                            break;
                    }
                    return accumulator;
                }, 0) });
        }
        case 'CHECKLIST_RESET_INSPECTION_SELECTED_FILTERS': {
            return Object.assign(Object.assign({}, state), { inspectionSelectedFilters: Object.assign({}, emptyFilters), inspectionSelectedFiltersLength: 0 });
        }
        case 'CHECKLIST_SET_INSPECTION_TEMPLATE_ITEMS': {
            const { items } = (_j = action.payload) !== null && _j !== void 0 ? _j : {};
            return Object.assign(Object.assign({}, state), { inspectionFiltersData: Object.assign(Object.assign({}, state.inspectionFiltersData), { template: (_k = items) !== null && _k !== void 0 ? _k : [] }) });
        }
        case 'CHECKLIST_SET_INSPECTION_EMPLOYEE_ITEMS': {
            const { items } = (_l = action.payload) !== null && _l !== void 0 ? _l : {};
            return Object.assign(Object.assign({}, state), { inspectionFiltersData: Object.assign(Object.assign({}, state.inspectionFiltersData), { employee: (_m = items) !== null && _m !== void 0 ? _m : [] }) });
        }
        case 'CHECKLIST_SET_INSPECTION_TRANSPORT_ITEMS': {
            const { items } = (_o = action.payload) !== null && _o !== void 0 ? _o : {};
            return Object.assign(Object.assign({}, state), { inspectionFiltersData: Object.assign(Object.assign({}, state.inspectionFiltersData), { transport: (_p = items) !== null && _p !== void 0 ? _p : [] }) });
        }
        case 'CHECKLIST_SET_TEMPLATE_ITEMS': {
            const { items } = (_q = action.payload) !== null && _q !== void 0 ? _q : {};
            return Object.assign(Object.assign({}, state), { templateItems: (_r = items) !== null && _r !== void 0 ? _r : [] });
        }
        case 'CHECKLIST_SET_TEMPLATE_SELECTED_ITEM': {
            const { data } = (_s = action.payload) !== null && _s !== void 0 ? _s : {};
            return Object.assign(Object.assign({}, state), { templateSelectedItem: data
                    ? Object.assign(Object.assign({}, data), { history: [] }) : null });
        }
        case 'CHECKLIST_SET_TEMPLATE_SEARCH_VALUE': {
            const { value } = (_t = action.payload) !== null && _t !== void 0 ? _t : {};
            return Object.assign(Object.assign({}, state), { templateSearchValue: value !== null && value !== void 0 ? value : '' });
        }
        case 'CHECKLIST_SET_TEMPLATE_SORT_SELECTED_ITEM': {
            const data = (_u = action.payload) === null || _u === void 0 ? void 0 : _u.data;
            if (!data) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { templateSortSelectedItem: {
                    name: data.name,
                    order: state.templateSortSelectedItem.name !== data.name ? data.order : state.templateSortSelectedItem.order === 'ASC' ? 'DESC' : 'ASC',
                } });
        }
        case 'CHECKLIST_ADD_TEMPLATE_LIST_ITEM': {
            const data = (_v = action.payload) === null || _v === void 0 ? void 0 : _v.data;
            if (!data) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { templateItems: [...state.templateItems, data] });
        }
        case 'CHECKLIST_UPDATE_TEMPLATE_LIST_ITEM': {
            const data = (_w = action.payload) === null || _w === void 0 ? void 0 : _w.data;
            if (!data) {
                return state;
            }
            const res = Object.assign(Object.assign({}, state), { templateItems: state.templateItems.map((item) => {
                    if (item.id !== data.id) {
                        return item;
                    }
                    return Object.assign(Object.assign({}, item), data);
                }) });
            if (state.templateSelectedItem && data.id === state.templateSelectedItem.id) {
                res.templateSelectedItem = Object.assign(Object.assign({}, state.templateSelectedItem), data);
            }
            return res;
        }
        case 'CHECKLIST_SET_TEMPLATE_GROUP_ITEMS': {
            const { items } = (_x = action.payload) !== null && _x !== void 0 ? _x : {};
            return Object.assign(Object.assign({}, state), { templateGroupItems: (_y = items) !== null && _y !== void 0 ? _y : [] });
        }
        case 'CHECKLIST_SET_TEMPLATE_HISTORY_ITEMS': {
            const { items } = (_z = action.payload) !== null && _z !== void 0 ? _z : {};
            if (!state.templateSelectedItem) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { templateSelectedItem: Object.assign(Object.assign({}, state.templateSelectedItem), { history: (_0 = items) !== null && _0 !== void 0 ? _0 : [] }) });
        }
        case 'CHECKLIST_SET_GROUP_ITEMS': {
            const { items } = (_1 = action.payload) !== null && _1 !== void 0 ? _1 : {};
            return Object.assign(Object.assign({}, state), { groupItems: (_2 = items) !== null && _2 !== void 0 ? _2 : [] });
        }
        case 'CHECKLIST_SET_GROUP_SEARCH_VALUE': {
            const { value } = (_3 = action.payload) !== null && _3 !== void 0 ? _3 : {};
            return Object.assign(Object.assign({}, state), { groupSearchValue: value !== null && value !== void 0 ? value : '' });
        }
        case 'CHECKLIST_ADD_GROUP_ITEM': {
            const data = (_4 = action.payload) === null || _4 === void 0 ? void 0 : _4.data;
            if (!data) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { groupItems: [...state.groupItems, data] });
        }
        case 'CHECKLIST_UPDATE_GROUP_ITEM': {
            const data = (_5 = action.payload) === null || _5 === void 0 ? void 0 : _5.data;
            if (!data) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { groupItems: state.groupItems.map((item) => {
                    if (item.id !== data.id) {
                        return item;
                    }
                    return Object.assign(Object.assign({}, item), data);
                }) });
        }
        case 'CHECKLIST_SET_GROUP_SELECTED_ITEM': {
            const { data } = (_6 = action.payload) !== null && _6 !== void 0 ? _6 : {};
            return Object.assign(Object.assign({}, state), { groupSelectedItem: data
                    ? Object.assign(Object.assign({}, data), { transports: [] }) : null });
        }
        case 'CHECKLIST_SET_GROUP_SELECTED_ITEM_DATA': {
            const { items } = (_7 = action.payload) !== null && _7 !== void 0 ? _7 : {};
            if (!state.groupSelectedItem) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { groupSelectedItem: Object.assign(Object.assign({}, state.groupSelectedItem), { transports: (_8 = items) !== null && _8 !== void 0 ? _8 : [] }) });
        }
        case 'CHECKLIST_SET_GROUP_SELECTED_ITEM_TRANSPORT': {
            const { id } = (_9 = action.payload) !== null && _9 !== void 0 ? _9 : {};
            if (!state.groupSelectedItem) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { groupSelectedItem: Object.assign(Object.assign({}, state.groupSelectedItem), { transports: ((_10 = state.groupSelectedItem.transports) !== null && _10 !== void 0 ? _10 : []).map((item) => {
                        if (item.id !== id) {
                            return item;
                        }
                        return Object.assign(Object.assign({}, item), { checked: !item.checked });
                    }) }) });
        }
        case 'CHECKLIST_SET_GROUP_SELECTED_ITEMS_TRANSPORT': {
            const { bool } = (_11 = action.payload) !== null && _11 !== void 0 ? _11 : {};
            if (!state.groupSelectedItem) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { groupSelectedItem: Object.assign(Object.assign({}, state.groupSelectedItem), { transports: ((_12 = state.groupSelectedItem.transports) !== null && _12 !== void 0 ? _12 : []).map((item) => (Object.assign(Object.assign({}, item), { checked: !!bool }))) }) });
        }
        case 'CHECKLIST_SET_TEMPLATE_AUTOCOLONS_ITEMS': {
            const { items } = (_13 = action.payload) !== null && _13 !== void 0 ? _13 : {};
            if (!state.templateSelectedItem) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { templateSelectedItem: Object.assign(Object.assign({}, state.templateSelectedItem), { autocolons: (_14 = items) !== null && _14 !== void 0 ? _14 : [] }) });
        }
        default:
            return state;
    }
};
const inspectionListQuery = (params) => {
    var _a, _b, _c, _d;
    return ({
        limit: params.limit,
        offset: params.offset,
        search: params.search || undefined,
        sort: params.sort,
        order: params.order,
        from: params.from || undefined,
        to: params.to || undefined,
        status: ((_a = params.status) === null || _a === void 0 ? void 0 : _a.join(',')) || undefined,
        template_id: ((_b = params.template_id) === null || _b === void 0 ? void 0 : _b.join(',')) || undefined,
        employee_id: ((_c = params.employee_id) === null || _c === void 0 ? void 0 : _c.join(',')) || undefined,
        transport_id: ((_d = params.transport_id) === null || _d === void 0 ? void 0 : _d.join(',')) || undefined,
        export: params.export ? 1 : undefined,
    });
};
export function inspectionLoad(params) {
    return function inspectionLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestVersion = params.append ? inspectionListRequestVersion : ++inspectionListRequestVersion;
            const { data } = yield http.get('/checklist/inspection/list', {
                params: inspectionListQuery(params),
            });
            if (requestVersion !== inspectionListRequestVersion) {
                return;
            }
            return dispatch(actions.setInspectionItems(data.items, data.has_more, params.append));
        });
    };
}
export function inspectionDetailLoad(item) {
    return function inspectionDetailLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestVersion = ++inspectionDetailRequestVersion;
            dispatch(actions.setInspectionSelectedItem(Object.assign(Object.assign({}, item), { details_loaded: false })));
            const { data } = yield http.get(`/checklist/inspection/${item.id}`);
            if (requestVersion !== inspectionDetailRequestVersion) {
                return;
            }
            return dispatch(actions.setInspectionSelectedItem(Object.assign(Object.assign(Object.assign({}, item), data), { created_at: item.created_at, inspected_at: item.inspected_at, delivered_at: item.delivered_at, details_loaded: true })));
        });
    };
}
export function inspectionExportLoad(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield http.get('/checklist/inspection/list', {
            params: inspectionListQuery(Object.assign(Object.assign({}, params), { export: true })),
        });
        return data.items.map(normalizeInspectionItem);
    });
}
export function inspectionFilterLoad() {
    return function inspectionFilterLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/checklist/inspection/filter');
            return batch(() => {
                dispatch(actions.setInspectionTemplateItems(data.template));
                dispatch(actions.setInspectionEmployeeItems(data.employee));
                dispatch(actions.setInspectionTransportItems(data.transport));
            });
        });
    };
}
export function templateLoad() {
    return function templateLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/checklist/template');
            return dispatch(actions.setTemplateItems(data));
        });
    };
}
export function templateCreate(params) {
    return function templateCreateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post(`/checklist/template`, params);
            return dispatch(actions.addTemplateListItem(data));
        });
    };
}
export function templateUpdate(params) {
    return function templateUpdateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.put(`/checklist/template/${params.id}`, params);
            return dispatch(actions.updateTemplateListItem(data));
        });
    };
}
export function templateDataLoad(id) {
    return function templateDataLoadLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get(`/checklist/template/${id}`);
            return dispatch(actions.setTemplateHistoryItems(data.history));
        });
    };
}
export function templateGroupLoad() {
    return function templateGroupLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/checklist/group');
            return dispatch(actions.setTemplateGroupItems(data));
        });
    };
}
export function groupLoad() {
    return function groupLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/checklist/group');
            return dispatch(actions.setGroupItems(data));
        });
    };
}
export function groupCreate(params) {
    return function groupCreateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post('/checklist/group', params);
            return dispatch(actions.addGroupListItem(data));
        });
    };
}
export function groupUpdate(id, params) {
    return function groupCreateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.put(`/checklist/group/${id}`, params);
            return dispatch(actions.updateGroupListItem(data));
        });
    };
}
export function groupDataLoad(id, params) {
    return function groupDataLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get(`/checklist/group/${id}`, params);
            return dispatch(actions.setGroupSelectedItemData(data));
        });
    };
}
export function groupTransportPush(id, value) {
    return function groupTransportPushThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.post(`/checklist/group/${id}/transport/${value}`);
            return dispatch(actions.setGroupSelectedItemTransport(value));
        });
    };
}
export function groupTransportDelete(id, value) {
    return function groupTransportDeleteThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.delete(`/checklist/group/${id}/transport/${value}`);
            return dispatch(actions.setGroupSelectedItemTransport(value));
        });
    };
}
export function groupTransportsPush(id, list) {
    return function groupTransportPushThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.post(`/checklist/group/${id}/transports`, {
                list,
            });
            return dispatch(actions.setGroupSelectedItemsTransport(true));
        });
    };
}
export function groupTransportsDelete(id) {
    return function groupTransportDeleteThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.delete(`/checklist/group/${id}/transports`);
            return dispatch(actions.setGroupSelectedItemsTransport(false));
        });
    };
}
export function downloadPdf(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield http.get(`/checklist/inspection/${id}/pdf`, {
            responseType: 'blob',
        });
    });
}
export const downloadDamageReport = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield http.get('/checklist/damage-report', {
            responseType: 'blob',
        });
        const blob = response.data;
        if (!(blob instanceof Blob)) {
            throw new Error('Получены данные не в формате Blob');
        }
        if (blob.size === 0) {
            throw new Error('Получен пустой файл');
        }
        const currentDate = new Date().toISOString().split('T')[0];
        const fileName = `Отчет_по_повреждениям_${currentDate}.xlsx`;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        return true;
    }
    catch (_a) {
        return false;
    }
});
export function checklistAutocolonPush(id, value) {
    return function groupTransportPushThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post(`/checklist/template/${id}/autocolon/${value}`);
            return dispatch(actions.updateTemplateListItem(data));
        });
    };
}
export function checklistAutocolonDelete(id, value) {
    return function groupTransportDeleteThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.delete(`/checklist/template/${id}/autocolon/${value}`);
            return dispatch(actions.updateTemplateListItem(data));
        });
    };
}
export function checklistAutocolonsPush(id, list) {
    return function groupTransportPushThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post(`/checklist/template/${id}/autocolons`, {
                list,
            });
            return dispatch(actions.updateTemplateListItem(data));
        });
    };
}
export function checklistAutocolonsListDelete(id, list) {
    return function groupTransportPushThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post(`/checklist/template/${id}/autocolons/delete`, {
                list,
            });
            return dispatch(actions.updateTemplateListItem(data));
        });
    };
}
export function checklistAutocolonsDelete(id) {
    return function groupTransportDeleteThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.delete(`/checklist/template/${id}/autocolons`);
            return dispatch(actions.updateTemplateListItem(data));
        });
    };
}
export function templateAutocolonsLoad(id) {
    return function templateDataLoadLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get(`/checklist/template/${id}/autocolons`);
            return dispatch(actions.setTemplateAutocolonsItems(data.autocolons));
        });
    };
}
export default checklistReducer;
